import { createFileRoute } from "@tanstack/react-router";
import { DemoHomeLayout } from "@/layout/demo/DemoHomeLayout";

export const Route = createFileRoute("/demo")({
  component: DemoHomeLayout,
});
